// 横キーモード（上段・中段・下段・数字）
export const TYPING_MODE_KEYS_ROW = {
  upper: {
    name: '上段キー',
    keys: ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P']
  },
  home: {
    name: '中段キー',
    keys: ['A', 'S', 'D', 'F', 'J', 'K', 'L']
  },
  lower: {
    name: '下段キー',
    keys: ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
  },
  numbers: {
    name: '数字キー',
    keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
  }
};
